import { render } from "./TOIndex.vue?vue&type=template&id=790f623e"
import script from "./TOIndex.vue?vue&type=script&lang=js"
export * from "./TOIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__